import React from 'react'
import PropTypes from 'prop-types'
import SimpleReactCalendar from 'simple-react-calendar'
import Icon from 'components/Icon'
import classnames from 'classnames'
import startOfWeek from 'date-fns/start_of_week'
import endOfWeek from 'date-fns/end_of_week'
import moment from 'moment'

export default class WeekCalendar extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    today: PropTypes.instanceOf(Date),
    selected: PropTypes.object,
    onApply: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      highlightStart: null,
      highlightEnd: null
    }
  }

  render() {
    const {
      minDate,
      maxDate,
      today,
      selected: {start},
      className
    } = this.props
    const {
      highlightStart, highlightEnd
    } = this.state

    const classNames = classnames('calendar-range-week', className)
    const highlighted = (highlightStart && highlightEnd)
      ? {start: highlightStart, end: highlightEnd} : null

    return (
      <div className={classNames}>
        <SimpleReactCalendar
          headerPrevArrow={<Icon className='calendar_icon-left' name='chevron' size='10px' />}
          headerNextArrow={<Icon className='calendar_icon-right' name='chevron' size='10px' />}
          maxDate={maxDate}
          minDate={minDate}
          selected={start || today}
          highlighted={highlighted}
          onSelect={this.onSelect}
          onDayHover={this.onWeekHover}
          mode='single'
        />
      </div>
    )
  }

  onWeekHover = date => {
    this.setState({
      highlightStart: startOfWeek(date, {weekStartsOn: 1}),
      highlightEnd: endOfWeek(date, {weekStartsOn: 1})
    })
  }

  onSelect = date => {
    const {onApply} = this.props

    onApply({
      start: startOfWeek(date, {weekStartsOn: 1}),
      end: endOfWeek(date, {weekStartsOn: 1})
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/Calendar/WeekCalendar.js